/** Allows the user to edit a booking request based on
 * provided selected offers.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment';
import { List, Map, Set } from 'immutable';

import OffersSummary from './OffersSummary';
import OfferDetails from './OfferDetails';
import PassengerEditor, { validateEmailAddress, validatePhoneNumber } from './PassengerEditor';
import './MakeBooking.css';
import scrollToComponent from 'react-scroll-to-component';

import { createOrder } from '../api';
import { createBookingTicket } from '../api';

class MakeBooking extends Component {
  constructor() {
    super();
    this.state = {
      passengers: new List(),
      passengersAreValid: false,
      showErrors: false,
      termsAccepted: false,
      processingCreateOrder: false,
      createOrderError: null,
      createOrderResponse: null,
      loadingProgress: 25,
      hasError: false,
      hasTicket: false,
    };
  }

  componentWillMount() {
    // console.log(this.props.requiredPassenger.count());
    let newList = this.state.passengers;
    for (let index = 0; index < this.props.requiredPassenger.count(); index++) {
      newList = newList.push(
        Map.of(
          'ageClassification',
          this.props.requiredPassenger.getIn([index, 'ageClassification']),
          'title',
          '',
          'firstname',
          '',
          'middlename',
          '',
          'surname',
          '',
          'day',
          '',
          'month',
          '',
          'year',
          '',
          'email',
          '',
          'phoneNumber',
          '',
          'phoneCode',
          '',
          'dirty_title',
          false,
          'dirty_firstname',
          false,
          'dirty_middlename',
          false,
          'dirty_surname',
          false,
          'dirty_day',
          false,
          'dirty_month',
          false,
          'dirty_year',
          false,
          'dirty_email',
          false,
          'dirty_phoneNumber',
          false,
          'dirty_phoneCode',
          false
        )
      );
    }
    this.setState({
      passengers: newList,
    });
  }

  componentDidMount() {
    scrollToComponent(this.ref, { offset: 0, align: 'top', duration: 500, ease: 'inQuad' });
  }

  updatePassengerList = (passengers) => {
    this.setState({ passengers, passengersAreValid: this.validatePassengers(passengers) });
  };

  validatePassengers = (passengers) => {
    return passengers.reduce((bool, p) => {
      return bool && this.validatePassenger(p);
    }, true);
  };

  getAgeClassification = (dob) => {
    const age = moment().diff(dob, 'years');
    return dob.isValid() ?( age < 2 ? 'INFANT' : age < 12 ? 'CHILD' : 'ADULT') : 'INVALID';
  };

  validatePassenger = (p) => {
    const dob = moment(p.get('year') + '-' + p.get('month') + '-' + (parseInt(p.get('day'), 10) < 10 ? '0' : '') + parseInt(p.get('day'), 10));
    const classification = this.getAgeClassification(dob);
    // console.log(p.get('ageClassification'));
    // console.log(classification);
    return (
      p.get('ageClassification') === classification &&
      p.get('title') !== '' &&
      !(p.get('day') < 1 || p.get('day') > 31 || p.get('month') === '' || p.get('year') < 1900 || p.get('year') > 2999) &&
      p.get('firstname') !== '' &&
      p.get('surname') !== '' &&
      validateEmailAddress(p.get('email')) &&
      validatePhoneNumber('' + p.get('phoneCode').substring(2, p.get('phoneCode').length) + p.get('phoneNumber'))
    );
  };

  toggleTermsAndCondition = (evt) => {
    this.setState({ termsAccepted: evt.target.checked });
  };

  createBooking = () => {
    if (!this.state.passengersAreValid) {
      this.setState({ showErrors: true });
    } else {
      this.setState({
        processingCreateOrder: true,
        createOrderError: null,
      });

      const order = this.props.selectedOffers.reduce(
        (list, so) => list.push(Map.of('offer', so.get('uri', 'termsAccepted', this.state.termsAccepted))),
        new List()
      );

      const getEmailAndPhoneNumberAsContactChannelList = (p) => {
        return new List()
          .push(Map.of('uri', 'mailto:' + p.get('email')))
          .push(Map.of('uri', 'tel:' + p.get('phoneCode').substring(2, p.get('phoneCode').length) + p.get('phoneNumber')));
      };

      const participants = this.state.passengers.reduce((l, p) => {
        const dob = moment(p.get('year') + '-' + p.get('month') + '-' + (parseInt(p.get('day'), 10) < 10 ? '0' : '') + parseInt(p.get('day'), 10));

        return l.push(
          Map.of(
            'name',
            Map.of(
              'title',
              p.get('title').toUpperCase(),
              'first',
              p.get('firstname'),
              'middle',
              p.get('middlename') ? p.get('middlename') : '',
              'last',
              p.get('surname')
            ),
            'birthDate',
            dob.format('YYYY-MM-DD'),
            'contact',
            getEmailAndPhoneNumberAsContactChannelList(p),
            'ageClassification',
            this.getAgeClassification(dob)
          )
        );
      }, new List());

      const request = Map.of(
        'company',
        this.props.company,
        // "company","http://www.myclient.com",
        'order',
        order,
        'participant',
        participants
      );

      this.setState({ loadingProgress: 45 });
      createOrder(request)
        .then((createOrderResponse = Map()) => {
          let allBookingFailed = createOrderResponse.get('result', List()).reduce((f, r) => f && r.get('isA') !== 'SuccessfulOrder', true);

          if (allBookingFailed) {
            this.setState({
              loadingProgress: 100,
              processingCreateOrder: false,
              hasError: true,
              createOrderResponse,
            });
            try {
              createBookingTicket(
                this.buildCreateBookingTicketRequest(
                  createOrderResponse.get('result', List()),
                  this.props.selectedOffers,
                  this.state.passengers,
                  this.props.company
                )
              )
                .then((resp) => {
                  this.setState({ hasTicket: true });
                })
                .catch((error) => {
                  this.setState({ hasTicket: false });
                });
            } catch (e) {}
          } else {
            this.setState({
              loadingProgress: 100,
              processingCreateOrder: false,
              hasError: false,
              createOrderResponse,
            });
            try {
              createBookingTicket(
                this.buildCreateBookingTicketRequest(
                  createOrderResponse.get('result', List()),
                  this.props.selectedOffers,
                  this.state.passengers,
                  this.props.company
                )
              );
            } catch (e) {}
            this.props.updateBookingConfirmation(createOrderResponse.get('result'));
            // this.props.cancel();
            // return Promise.resolve(createOrderResponse)
          }
        })
        .catch((createOrderError) => {
          console.warn(createOrderError.toString());

          this.setState({
            loadingProgress: 100,
            processingCreateOrder: false,
            createOrderError,
            hasError: true,
          });
        });
    }
  };

  buildCreateBookingTicketRequest(cor, so, pars, company) {
    let message = 'The user has selected the following services:\n';

    const parseParticipant = (p) => {
      return `${p.get('title')} ${p.get('firstname')} ${p.get('surname')} | ${p.get('email')} | ${p.get('phoneNumber')}`;
    };

    const parseServiceDetail = (s) => {
      if (s.get('connectingFlightDetail', List()).isEmpty()) {
        return (
          s.get('from').replace('http://www.iata.org/airportCode/', '') +
          ' to ' +
          s.get('to').replace('http://www.iata.org/airportCode/', '') +
          ' on ' +
          moment(s.get('commence')).format('YYYY-MM-DD') +
          '\n' +
          s.get('flightNumber') +
          ' ' +
          s.get('cabinClass') +
          ' (' +
          s.get('airlineBookingCode') +
          ')\n' +
          moment(s.get('commence')).format('hh:mm') +
          ' - ' +
          moment(s.get('complete')).format('hh:mm')
        );
      } else {
        const parseConnectingFlightDetail = (cfd) => {
          return (
            cfd.get('from').replace('http://www.iata.org/airportCode/', '') +
            ' to ' +
            cfd.get('to').replace('http://www.iata.org/airportCode/', '') +
            ' ' +
            cfd.get('flightNumber') +
            ' (' +
            cfd.get('airlineBookingCode') +
            ')\n'
          );
        };
        return (
          s.get('from').replace('http://www.iata.org/airportCode/', '') +
          ' to ' +
          s.get('to').replace('http://www.iata.org/airportCode/', '') +
          ' [' +
          s.get('cabinClass') +
          '] on ' +
          moment(s.get('commence')).format('YYYY-MM-DD') +
          '\n' +
          moment(s.get('commence')).format('hh:mm') +
          ' - ' +
          moment(s.get('complete')).format('hh:mm') +
          '\n' +
          s.get('connectingFlightDetail').reduce((m, cfd) => m + parseConnectingFlightDetail(cfd) + '\n', '')
        );
      }
    };

    const parseOffer = (o) => {
      return (
        '\nValidating Carrier: ' +
        o.getIn(['validatingServiceProvider', 'name']) +
        ' (' +
        o.getIn(['validatingServiceProvider', 'industryIdentifier', 'identifier']) +
        ')' +
        '\nCost: ' +
        o.getIn(['cost', 'currency']) +
        ' ' +
        o.getIn(['cost', 'amount']) +
        '\nTrip Details\n\n' +
        o.get('serviceDetail').reduce((m, sd) => m + parseServiceDetail(sd) + '\n', '')
      );
    };

    message =
      so.reduce((newMsg, offer) => newMsg + parseOffer(offer), message) +
      '\nTravellers count: ' +
      pars.count() +
      '\nTravellers: \n' +
      pars.reduce((m, p) => m + parseParticipant(p) + '\n', '');

    const bookingChannelConfirmationSet = cor.reduce(
      (set, oc) =>
        oc.has('orderConfirmation')
          ? set.add('PNR: ' + oc.getIn(['orderConfirmation', 'bookingChannelConfirmation']))
          : set.add('At least one order failed'),
      Set()
    );
    const pnrs = bookingChannelConfirmationSet.join(',');
    message = message + '\n\n Status: ' + pnrs;

    let createBookingTicketRequest = Map.of(
      'company',
      company,
      'addTicketRequest',
      Map.of(
        'parameters',
        Map.of(
          'name',
          pars.getIn([0, 'firstname']) + ' ' + pars.getIn([0, 'surname']),
          'email',
          pars.getIn([0, 'email']),
          'service',
          1,
          'priority',
          1,
          'department',
          1,
          'subject',
          'Booking request on Web UI for ' + pars.getIn([0, 'firstname']) + ' ' + pars.getIn([0, 'surname']),
          'message',
          message
        )
      )
    );

    return createBookingTicketRequest;
  }

  render() {
    const { cancel, selectedOffers, airportByIata } = this.props;

    // const totalCost = selectedOffers.reduce((total, offer) => {
    //   return total + offer.getIn(["cost", "amount"]);
    // }, 0);
    // const currency = selectedOffers.get(0).getIn(["cost", "currency"]);

    return (
      <div className='booking-request container' ref={(div) => (this.ref = div)}>
        {!this.state.processingCreateOrder && (
          <div className='back-nav'>
            <a
              className='back-to-hotel-search'
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault();
                cancel();
              }}
            >
              <i className='back'></i> <span>Back to search results</span>
            </a>
            <br />
            <br />
          </div>
        )}
        {!this.state.processingCreateOrder ? (
          !this.state.hasError ? (
            <div>
              <OffersSummary offers={selectedOffers} airportByIata={airportByIata} />
              <div className='flights-book-list'>
                {selectedOffers.map((offer, i) => {
                  return <OfferDetails key={i} offer={offer} airportByIata={airportByIata} />;
                })}
              </div>

              <section id='passengers' className='book-section'>
                <h2>Passengers</h2>
                <PassengerEditor
                  passengers={this.state.passengers}
                  onPassengerListUpdate={this.updatePassengerList.bind(this)}
                  showErrors={this.state.showErrors}
                />
              </section>

              <section className='terms-policy book-section'>
                <div className='row'>
                  <div className='col-md-16'>
                    <ul className='bg-info more-info-list'>
                      {/*{<li>
                          Airlines reserve the right to change ticket fare if purchased later than <b>  {moment(selectedOffers.get("validUntil")).format("dddd, DD MMMM YYYY")}</b>.
                        </li>
                        <li>
                          Your selection does not require immediate purchase. If you choose to purchase it now, <strong>{currency} {totalCost}</strong> will be debited from your credit card; whereas the service fees will be invoiced by your agency.
                        </li>}*/}
                      <li>Please note that the fare is not guaranteed until the ticket is issued.</li>
                    </ul>
                    {/*<ul className="info-links">
                         <li className="actions rate-rules">
                           <a id="rental_policy_2" href="#" key="5edc167d-a1d5-48f2-8515-7838c31f54b6" data-toggle="modal" data-target="#fare-rules-modal">Fare Rules</a>
                         </li>
                      </ul>*/}
                  </div>
                  <div className='col-md-8 price-result-col'>
                    <div className='col-wrapper'>
                      <CostBreakDown selectedOffers={selectedOffers} />
                    </div>
                  </div>
                </div>
              </section>

              <section className='purchase-bar book-section'>
                <i className='l-face'></i>
                <label className='css-checkbox' htmlFor='TripBookingTermsAndContitions'>
                  <input type='checkbox' value='true' onChange={this.toggleTermsAndCondition} id='TripBookingTermsAndContitions' />
                  <i></i>
                  <span>
                    I confirm that I have read, understood and agree with the
                    <b>
                      {/*<a id="termsAndConditionsLink" href="http://developer.ean.com/terms/agent/en/">*/} TERMS AND CONDITIONS and CANCELLATION
                      POLICY
                    </b>{' '}
                    provided.
                  </span>
                </label>
              </section>

              <footer>
                <div className='row footer-buttons'>
                  <button
                    type='submit'
                    id='FlightBookingPurchaceLater'
                    value='Cancel'
                    onClick={cancel}
                    className='btn btn-nx btn-danger book min-width-140'
                  >
                    Cancel
                  </button>
                  {/*<button type="submit" id="FlightBookingPurchaceLater" value="BookLater" onClick={cancel} className="btn btn-nx btn-def book">Purchase Later</button>*/}
                  <button
                    type='submit'
                    id='FlightBookingPurchaceNow'
                    value='Book'
                    className='btn btn-primary book min-width-140'
                    disabled={!this.state.termsAccepted}
                    onClick={this.createBooking}
                  >
                    Book
                  </button>
                </div>
              </footer>
            </div>
          ) : (
            <div className='container'>
              <br />
              <br />
              <div className='alert alert-danger'>
                Booking process has failed. {this.state.hasTicket ? `We've contacted an agent with your details.` : ''}
              </div>
            </div>
          )
        ) : (
          <div className='container'>
            <br />
            <br />
            <div className='progress'>
              <div className='progress-bar progress-bar-striped active' role='progressbar' style={{ width: `${this.state.loadingProgress}%` }}>
                <span className='sr-only'>Booking...</span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const CostBreakDown = ({ selectedOffers }) => {
  // TODO will  have to refactor or completely scrap if in the future we have a complex fare constructed across multiple pricing sources
  const totalCost = selectedOffers.reduce((total, offer) => {
    return total + offer.getIn(['cost', 'amount']);
  }, 0);
  const currency = selectedOffers.get(0).getIn(['cost', 'currency']);
  let totalBaseFare = selectedOffers.reduce((total, offer) => {
    return (
      total +
      offer.getIn(['cost', 'component']).reduce((subtotal, component) => {
        return subtotal + (component.get('description') === 'Base Fare' ? component.get('amount') : 0);
      }, 0)
    );
  }, 0);
  const totalTaxes = selectedOffers.reduce((total, offer) => {
    return (
      total +
      offer.getIn(['cost', 'component']).reduce((subtotal, component) => {
        return subtotal + (component.get('description') === 'Taxes' ? component.get('amount') : 0);
      }, 0)
    );
  }, 0);
  const totalServiceFee = selectedOffers.reduce((total, offer) => {
    return (
      total +
      offer.getIn(['cost', 'component']).reduce((subtotal, component) => {
        return subtotal + (component.get('description') === 'Service Fee' ? component.get('amount') : 0);
      }, 0)
    );
  }, 0);

  const components = selectedOffers.get(0).getIn(['cost', 'component']);
  let baseFareCurrency = components.reduce((i, comp) => {
    return comp.get('description') === 'Base Fare' ? comp.get('currency') : i + '';
  }, '');
  const taxesCurrency = components.reduce((i, comp) => {
    return comp.get('description') === 'Taxes' ? comp.get('currency') : i + '';
  }, '');
  const serviceFeeCurrency = components.reduce((i, comp) => {
    return comp.get('description') === 'Service Fee' ? comp.get('currency') : i + '';
  }, '');

  /*FIXME Hack to change base fare currency to MUR (or same as total amount' currency) when it's given in another*/
  let showConverted = false;
  let convertedbaseFareCurrency = '';
  let convertedBaseFare = '';
  if (currency === serviceFeeCurrency && currency === taxesCurrency && currency !== baseFareCurrency) {
    showConverted = true;
    convertedbaseFareCurrency = currency;
    convertedBaseFare = totalCost - (totalServiceFee + totalTaxes);
  }

  return (
    <table className='table'>
      <tbody>
        <tr>
          <td>Base Fare</td>
          <td>
            {showConverted
              ? `${convertedbaseFareCurrency} ${convertedBaseFare} (${baseFareCurrency} ${totalBaseFare})`
              : `${baseFareCurrency} ${totalBaseFare}`}
          </td>
        </tr>
        <tr>
          <td>Taxes</td>
          <td>
            {taxesCurrency} {totalTaxes}
          </td>
        </tr>
        <tr>
          <td>Service Fees</td>
          <td>
            {serviceFeeCurrency} {totalServiceFee}
          </td>
        </tr>
        <tr>
          <td>Grand Total</td>
          <td>
            <label className='price'>
              <span>
                <em>
                  {currency} {totalCost}
                </em>
              </span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

MakeBooking.propTypes = {
  // company URI. String
  company: PropTypes.string.isRequired,
  // Cancels booking process. () -> ()
  cancel: PropTypes.func.isRequired,
  // Update booking confirmation list. () -> ()
  updateBookingConfirmation: PropTypes.func.isRequired,
  // List<OfferAsMap>
  selectedOffers: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
  // Map<IataCode,AirportAsMap>
  airportByIata: ImmutablePropTypes.map.isRequired,
  // List<PassengerAsMap>
  requiredPassenger: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
};

export default MakeBooking;



// WEBPACK FOOTER //
// ./src/ndc/booking/MakeBooking.js